import { AlertTriangle, ShieldAlert } from "lucide-react"
import { useTranslation } from "react-i18next"
import { PlanUsageStatus } from "../../Objects/Company/PlanUsageStatus"
import Animate, { AnimationTypes } from "../Animate/Animate"

interface Props {
  planUsageStatus: PlanUsageStatus
}

export function PlanUsageAlert({ planUsageStatus }: Props) {
  const { t } = useTranslation("order")

  if (!planUsageStatus.isNearLimit && !planUsageStatus.isLimitReached) {
    return null
  }

  const isLimit = planUsageStatus.isLimitReached

  return (
    <Animate type={AnimationTypes.fadeInTraslate}>
      <div
        className={`w-full mt-2 rounded-[0.5rem] ring-2 p-4 shadow-sm transition-all ${
          isLimit ? "ring-red-200" : "ring-orange-200"
        }`}
      >
        <div className="flex items-start gap-3">
          <div className={`p-2 rounded-xl ${isLimit ? "bg-red-100" : "bg-orange-100"}`}>
            {isLimit ? (
              <ShieldAlert className="w-5 h-5 text-red-600" />
            ) : (
              <AlertTriangle className="w-5 h-5 text-orange-600" />
            )}
          </div>

          <div className="flex-1">
            <p className={`text-sm font-semibold ${isLimit ? "text-red-700" : "text-orange-700"}`}>
              {t("label_plan_usage", {
                used: planUsageStatus.currentMonthOrders,
                limit: planUsageStatus.monthlyOrdersLimit,
                percent: planUsageStatus.usagePercent,
              })}
            </p>

            <p className={`text-xs mt-1 ${isLimit ? "text-red-600" : "text-gray-800"}`}>
              {isLimit ? t("message_plan_limit_reached") : t("message_plan_near_limit")}
            </p>

            <div className="mt-3">
              <div className="w-full h-2 bg-black/20 rounded-full overflow-hidden">
                <div
                  className={`h-full transition-all duration-500 ${isLimit ? "bg-red-500" : "bg-orange-500"}`}
                  style={{
                    width: `${Math.min(planUsageStatus.usagePercent, 100)}%`,
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Animate>
  )
}
